import { render, staticRenderFns } from "./prjIdSelect.vue?vue&type=template&id=6ac5c0d8&scoped=true&lang=pug"
import script from "./prjIdSelect.vue?vue&type=script&lang=js"
export * from "./prjIdSelect.vue?vue&type=script&lang=js"
import style0 from "./prjIdSelect.vue?vue&type=style&index=0&id=6ac5c0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac5c0d8",
  null
  
)

export default component.exports